/**
 * The pure, testable core of the free-text tag combobox (TRACK-B-1b §3.1).
 * Mirrors the server's normalization exactly (backend/src/utils/tagResolve.js):
 * trim + case-fold, and nothing else.
 */

/** Trim + case-fold. The ONLY normalization — no whitespace collapse, no Unicode folding. */
export function normalizeTagLabel (raw) {
  return typeof raw === 'string' ? raw.trim().toLowerCase() : '';
}

/** Hard cap on the rendered suggestion list — applies to EVERY query, the empty one included. */
export const MAX_TAG_SUGGESTIONS = 8;

/**
 * Suggestions for a typed query, filtered client-side over the cached directory.
 * An empty query returns the first 8 rows in directory order; a non-empty query keeps
 * every normalized substring match, sorts an exact normalized match first (so Enter
 * picks the reuse rather than a longer neighbour) and preserves directory order
 * otherwise. An empty or absent directory yields [] — a normal, typeable state.
 */
export function filterTagSuggestions (tags, query) {
  const list = Array.isArray(tags) ? tags : [];
  const q = normalizeTagLabel(query);
  if (!q) return list.slice(0, MAX_TAG_SUGGESTIONS);
  const matched = list.filter(t => normalizeTagLabel(t?.label).includes(q));

  matched.sort((a, b) => (normalizeTagLabel(b?.label) === q) - (normalizeTagLabel(a?.label) === q));
  return matched.slice(0, MAX_TAG_SUGGESTIONS);
}
